// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file workflows/v1/workflows.proto (package workflows.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { Any, AnyJson, Duration, DurationJson, ListValue, ListValueJson, StructJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_duration, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { Status, StatusJson } from "../../google/rpc/status_pb";
import { file_google_rpc_status } from "../../google/rpc/status_pb";
import type { Notification, NotificationJson } from "../../notifications/v2/notifications_pb";
import { file_notifications_v2_notifications } from "../../notifications/v2/notifications_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file workflows/v1/workflows.proto.
 */
export const file_workflows_v1_workflows: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_types, file_google_protobuf_any, file_google_protobuf_duration, file_google_protobuf_struct, file_google_rpc_status, file_notifications_v2_notifications],
	);

/**
 * @generated from message workflows.v1.OAuthParams
 */
export type OAuthParams = Message<"workflows.v1.OAuthParams"> & {
	/**
	 * @generated from field: string token_url = 1;
	 */
	tokenUrl: string;

	/**
	 * @generated from field: string client_id = 2;
	 */
	clientId: string;

	/**
	 * @generated from field: string client_secret = 3;
	 */
	clientSecret: string;

	/**
	 * @generated from field: repeated string scopes = 4;
	 */
	scopes: string[];

	/**
	 * @generated from field: map<string, string> extras = 5;
	 */
	extras: { [key: string]: string };
};

/**
 * @generated from message workflows.v1.OAuthParams
 */
export type OAuthParamsJson = {
	/**
	 * @generated from field: string token_url = 1;
	 */
	tokenUrl?: string;

	/**
	 * @generated from field: string client_id = 2;
	 */
	clientId?: string;

	/**
	 * @generated from field: string client_secret = 3;
	 */
	clientSecret?: string;

	/**
	 * @generated from field: repeated string scopes = 4;
	 */
	scopes?: string[];

	/**
	 * @generated from field: map<string, string> extras = 5;
	 */
	extras?: { [key: string]: string };
};

/**
 * Describes the message workflows.v1.OAuthParams.
 * Use `create(OAuthParamsSchema)` to create a new message.
 */
export const OAuthParamsSchema: GenMessage<OAuthParams, { jsonType: OAuthParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 0);

/**
 * @generated from message workflows.v1.ApiKey
 */
export type ApiKey = Message<"workflows.v1.ApiKey"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;
};

/**
 * @generated from message workflows.v1.ApiKey
 */
export type ApiKeyJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;
};

/**
 * Describes the message workflows.v1.ApiKey.
 * Use `create(ApiKeySchema)` to create a new message.
 */
export const ApiKeySchema: GenMessage<ApiKey, { jsonType: ApiKeyJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 1);

/**
 * @generated from message workflows.v1.BodyPagination
 */
export type BodyPagination = Message<"workflows.v1.BodyPagination"> & {
	/**
	 * @generated from field: google.protobuf.Struct pagination_template = 1;
	 */
	paginationTemplate?: JsonObject | undefined;

	/**
	 * @generated from field: string has_more_template = 2;
	 */
	hasMoreTemplate: string;
};

/**
 * @generated from message workflows.v1.BodyPagination
 */
export type BodyPaginationJson = {
	/**
	 * @generated from field: google.protobuf.Struct pagination_template = 1;
	 */
	paginationTemplate?: StructJson;

	/**
	 * @generated from field: string has_more_template = 2;
	 */
	hasMoreTemplate?: string;
};

/**
 * Describes the message workflows.v1.BodyPagination.
 * Use `create(BodyPaginationSchema)` to create a new message.
 */
export const BodyPaginationSchema: GenMessage<BodyPagination, { jsonType: BodyPaginationJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 2);

/**
 * @generated from message workflows.v1.PaginationConfig
 */
export type PaginationConfig = Message<"workflows.v1.PaginationConfig"> & {
	/**
	 * @generated from oneof workflows.v1.PaginationConfig.config
	 */
	config:
		| {
				/**
				 * @generated from field: workflows.v1.BodyPagination body = 1;
				 */
				value: BodyPagination;
				case: "body";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.PaginationConfig
 */
export type PaginationConfigJson = {
	/**
	 * @generated from field: workflows.v1.BodyPagination body = 1;
	 */
	body?: BodyPaginationJson;
};

/**
 * Describes the message workflows.v1.PaginationConfig.
 * Use `create(PaginationConfigSchema)` to create a new message.
 */
export const PaginationConfigSchema: GenMessage<PaginationConfig, { jsonType: PaginationConfigJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 3);

/**
 * @generated from message workflows.v1.HttpParams
 */
export type HttpParams = Message<"workflows.v1.HttpParams"> & {
	/**
	 * @generated from field: string method = 4;
	 */
	method: string;

	/**
	 * @generated from field: string url_template = 1;
	 */
	urlTemplate: string;

	/**
	 * @generated from field: string secret_id = 2;
	 */
	secretId: string;

	/**
	 * @generated from field: workflows.v1.AuthType auth_type = 3;
	 */
	authType: AuthType;

	/**
	 * @generated from field: google.protobuf.Struct body_template = 5;
	 */
	bodyTemplate?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Struct header_template = 6;
	 */
	headerTemplate?: JsonObject | undefined;

	/**
	 * @generated from field: workflows.v1.PaginationConfig pagination_config = 7;
	 */
	paginationConfig?: PaginationConfig | undefined;
};

/**
 * @generated from message workflows.v1.HttpParams
 */
export type HttpParamsJson = {
	/**
	 * @generated from field: string method = 4;
	 */
	method?: string;

	/**
	 * @generated from field: string url_template = 1;
	 */
	urlTemplate?: string;

	/**
	 * @generated from field: string secret_id = 2;
	 */
	secretId?: string;

	/**
	 * @generated from field: workflows.v1.AuthType auth_type = 3;
	 */
	authType?: AuthTypeJson;

	/**
	 * @generated from field: google.protobuf.Struct body_template = 5;
	 */
	bodyTemplate?: StructJson;

	/**
	 * @generated from field: google.protobuf.Struct header_template = 6;
	 */
	headerTemplate?: StructJson;

	/**
	 * @generated from field: workflows.v1.PaginationConfig pagination_config = 7;
	 */
	paginationConfig?: PaginationConfigJson;
};

/**
 * Describes the message workflows.v1.HttpParams.
 * Use `create(HttpParamsSchema)` to create a new message.
 */
export const HttpParamsSchema: GenMessage<HttpParams, { jsonType: HttpParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 4);

/**
 * @generated from message workflows.v1.SftpUser
 */
export type SftpUser = Message<"workflows.v1.SftpUser"> & {
	/**
	 * @generated from field: string user = 1;
	 */
	user: string;

	/**
	 * @generated from field: string password = 2;
	 */
	password: string;

	/**
	 * @generated from field: string private_key = 3;
	 */
	privateKey: string;
};

/**
 * @generated from message workflows.v1.SftpUser
 */
export type SftpUserJson = {
	/**
	 * @generated from field: string user = 1;
	 */
	user?: string;

	/**
	 * @generated from field: string password = 2;
	 */
	password?: string;

	/**
	 * @generated from field: string private_key = 3;
	 */
	privateKey?: string;
};

/**
 * Describes the message workflows.v1.SftpUser.
 * Use `create(SftpUserSchema)` to create a new message.
 */
export const SftpUserSchema: GenMessage<SftpUser, { jsonType: SftpUserJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 5);

/**
 * @generated from message workflows.v1.SftpParams
 */
export type SftpParams = Message<"workflows.v1.SftpParams"> & {
	/**
	 * @generated from field: string host = 1;
	 */
	host: string;

	/**
	 * @generated from field: string public_key = 2;
	 */
	publicKey: string;

	/**
	 * @generated from field: string secret_id = 3;
	 */
	secretId: string;

	/**
	 * @generated from field: string file_name = 4;
	 */
	fileName: string;
};

/**
 * @generated from message workflows.v1.SftpParams
 */
export type SftpParamsJson = {
	/**
	 * @generated from field: string host = 1;
	 */
	host?: string;

	/**
	 * @generated from field: string public_key = 2;
	 */
	publicKey?: string;

	/**
	 * @generated from field: string secret_id = 3;
	 */
	secretId?: string;

	/**
	 * @generated from field: string file_name = 4;
	 */
	fileName?: string;
};

/**
 * Describes the message workflows.v1.SftpParams.
 * Use `create(SftpParamsSchema)` to create a new message.
 */
export const SftpParamsSchema: GenMessage<SftpParams, { jsonType: SftpParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 6);

/**
 * @generated from message workflows.v1.Loader
 */
export type Loader = Message<"workflows.v1.Loader"> & {
	/**
	 * @generated from oneof workflows.v1.Loader.params
	 */
	params:
		| {
				/**
				 * @generated from field: workflows.v1.HttpParams http = 1;
				 */
				value: HttpParams;
				case: "http";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.SftpParams sftp = 2;
				 */
				value: SftpParams;
				case: "sftp";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.Loader
 */
export type LoaderJson = {
	/**
	 * @generated from field: workflows.v1.HttpParams http = 1;
	 */
	http?: HttpParamsJson;

	/**
	 * @generated from field: workflows.v1.SftpParams sftp = 2;
	 */
	sftp?: SftpParamsJson;
};

/**
 * Describes the message workflows.v1.Loader.
 * Use `create(LoaderSchema)` to create a new message.
 */
export const LoaderSchema: GenMessage<Loader, { jsonType: LoaderJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 7);

/**
 * @generated from message workflows.v1.S3Object
 */
export type S3Object = Message<"workflows.v1.S3Object"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: string url = 2;
	 */
	url: string;
};

/**
 * @generated from message workflows.v1.S3Object
 */
export type S3ObjectJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: string url = 2;
	 */
	url?: string;
};

/**
 * Describes the message workflows.v1.S3Object.
 * Use `create(S3ObjectSchema)` to create a new message.
 */
export const S3ObjectSchema: GenMessage<S3Object, { jsonType: S3ObjectJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 8);

/**
 * @generated from message workflows.v1.JsonOptions
 */
export type JsonOptions = Message<"workflows.v1.JsonOptions"> & {
	/**
	 * jsonpath syntax
	 *
	 * @generated from field: string data_path = 1;
	 */
	dataPath: string;
};

/**
 * @generated from message workflows.v1.JsonOptions
 */
export type JsonOptionsJson = {
	/**
	 * jsonpath syntax
	 *
	 * @generated from field: string data_path = 1;
	 */
	dataPath?: string;
};

/**
 * Describes the message workflows.v1.JsonOptions.
 * Use `create(JsonOptionsSchema)` to create a new message.
 */
export const JsonOptionsSchema: GenMessage<JsonOptions, { jsonType: JsonOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 9);

/**
 * @generated from message workflows.v1.CsvOptions
 */
export type CsvOptions = Message<"workflows.v1.CsvOptions"> & {
	/**
	 * @generated from field: bool has_header = 1;
	 */
	hasHeader: boolean;

	/**
	 * @generated from field: repeated string header = 2;
	 */
	header: string[];
};

/**
 * @generated from message workflows.v1.CsvOptions
 */
export type CsvOptionsJson = {
	/**
	 * @generated from field: bool has_header = 1;
	 */
	hasHeader?: boolean;

	/**
	 * @generated from field: repeated string header = 2;
	 */
	header?: string[];
};

/**
 * Describes the message workflows.v1.CsvOptions.
 * Use `create(CsvOptionsSchema)` to create a new message.
 */
export const CsvOptionsSchema: GenMessage<CsvOptions, { jsonType: CsvOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 10);

/**
 * @generated from message workflows.v1.XmlOptions
 */
export type XmlOptions = Message<"workflows.v1.XmlOptions"> & {
	/**
	 * xpath syntax
	 *
	 * @generated from field: string path = 1;
	 */
	path: string;

	/**
	 * defaults to utf8
	 *
	 * @generated from field: workflows.v1.CharacterEncoding encoding = 2;
	 */
	encoding: CharacterEncoding;
};

/**
 * @generated from message workflows.v1.XmlOptions
 */
export type XmlOptionsJson = {
	/**
	 * xpath syntax
	 *
	 * @generated from field: string path = 1;
	 */
	path?: string;

	/**
	 * defaults to utf8
	 *
	 * @generated from field: workflows.v1.CharacterEncoding encoding = 2;
	 */
	encoding?: CharacterEncodingJson;
};

/**
 * Describes the message workflows.v1.XmlOptions.
 * Use `create(XmlOptionsSchema)` to create a new message.
 */
export const XmlOptionsSchema: GenMessage<XmlOptions, { jsonType: XmlOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 11);

/**
 * @generated from message workflows.v1.BatchOptions
 */
export type BatchOptions = Message<"workflows.v1.BatchOptions"> & {
	/**
	 * @generated from field: int32 batch_size = 1;
	 */
	batchSize: number;

	/**
	 * @generated from field: int32 offset = 2;
	 */
	offset: number;
};

/**
 * @generated from message workflows.v1.BatchOptions
 */
export type BatchOptionsJson = {
	/**
	 * @generated from field: int32 batch_size = 1;
	 */
	batchSize?: number;

	/**
	 * @generated from field: int32 offset = 2;
	 */
	offset?: number;
};

/**
 * Describes the message workflows.v1.BatchOptions.
 * Use `create(BatchOptionsSchema)` to create a new message.
 */
export const BatchOptionsSchema: GenMessage<BatchOptions, { jsonType: BatchOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 12);

/**
 * @generated from message workflows.v1.Parser
 */
export type Parser = Message<"workflows.v1.Parser"> & {
	/**
	 * @generated from field: workflows.v1.ParserFormat format = 1;
	 */
	format: ParserFormat;

	/**
	 * @generated from oneof workflows.v1.Parser.options
	 */
	options:
		| {
				/**
				 * @generated from field: workflows.v1.JsonOptions json = 2;
				 */
				value: JsonOptions;
				case: "json";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.XmlOptions xml = 3;
				 */
				value: XmlOptions;
				case: "xml";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.CsvOptions csv = 5;
				 */
				value: CsvOptions;
				case: "csv";
		  }
		| { case: undefined; value?: undefined };

	/**
	 * @generated from field: workflows.v1.BatchOptions batch_options = 4;
	 */
	batchOptions?: BatchOptions | undefined;
};

/**
 * @generated from message workflows.v1.Parser
 */
export type ParserJson = {
	/**
	 * @generated from field: workflows.v1.ParserFormat format = 1;
	 */
	format?: ParserFormatJson;

	/**
	 * @generated from field: workflows.v1.JsonOptions json = 2;
	 */
	json?: JsonOptionsJson;

	/**
	 * @generated from field: workflows.v1.XmlOptions xml = 3;
	 */
	xml?: XmlOptionsJson;

	/**
	 * @generated from field: workflows.v1.CsvOptions csv = 5;
	 */
	csv?: CsvOptionsJson;

	/**
	 * @generated from field: workflows.v1.BatchOptions batch_options = 4;
	 */
	batchOptions?: BatchOptionsJson;
};

/**
 * Describes the message workflows.v1.Parser.
 * Use `create(ParserSchema)` to create a new message.
 */
export const ParserSchema: GenMessage<Parser, { jsonType: ParserJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 13);

/**
 * @generated from message workflows.v1.Splitter
 */
export type Splitter = Message<"workflows.v1.Splitter"> & {
	/**
	 * @generated from field: string element_path = 1;
	 */
	elementPath: string;

	/**
	 * @generated from field: string partition_path = 2;
	 */
	partitionPath: string;

	/**
	 * @generated from field: workflows.v1.BatchOptions batch_options = 3;
	 */
	batchOptions?: BatchOptions | undefined;

	/**
	 * @generated from field: int32 page_size = 4;
	 */
	pageSize: number;
};

/**
 * @generated from message workflows.v1.Splitter
 */
export type SplitterJson = {
	/**
	 * @generated from field: string element_path = 1;
	 */
	elementPath?: string;

	/**
	 * @generated from field: string partition_path = 2;
	 */
	partitionPath?: string;

	/**
	 * @generated from field: workflows.v1.BatchOptions batch_options = 3;
	 */
	batchOptions?: BatchOptionsJson;

	/**
	 * @generated from field: int32 page_size = 4;
	 */
	pageSize?: number;
};

/**
 * Describes the message workflows.v1.Splitter.
 * Use `create(SplitterSchema)` to create a new message.
 */
export const SplitterSchema: GenMessage<Splitter, { jsonType: SplitterJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 14);

/**
 * @generated from message workflows.v1.ParseParams
 */
export type ParseParams = Message<"workflows.v1.ParseParams"> & {
	/**
	 * @generated from field: google.protobuf.Struct context = 1;
	 */
	context?: JsonObject | undefined;

	/**
	 * @generated from field: workflows.v1.Parser parser = 2;
	 */
	parser?: Parser | undefined;

	/**
	 * @generated from field: workflows.v1.LoadResult load = 3;
	 */
	load?: LoadResult | undefined;
};

/**
 * @generated from message workflows.v1.ParseParams
 */
export type ParseParamsJson = {
	/**
	 * @generated from field: google.protobuf.Struct context = 1;
	 */
	context?: StructJson;

	/**
	 * @generated from field: workflows.v1.Parser parser = 2;
	 */
	parser?: ParserJson;

	/**
	 * @generated from field: workflows.v1.LoadResult load = 3;
	 */
	load?: LoadResultJson;
};

/**
 * Describes the message workflows.v1.ParseParams.
 * Use `create(ParseParamsSchema)` to create a new message.
 */
export const ParseParamsSchema: GenMessage<ParseParams, { jsonType: ParseParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 15);

/**
 * @generated from message workflows.v1.ParseResult
 */
export type ParseResult = Message<"workflows.v1.ParseResult"> & {
	/**
	 * @generated from field: google.protobuf.ListValue data = 1;
	 */
	data?: ListValue | undefined;
};

/**
 * @generated from message workflows.v1.ParseResult
 */
export type ParseResultJson = {
	/**
	 * @generated from field: google.protobuf.ListValue data = 1;
	 */
	data?: ListValueJson;
};

/**
 * Describes the message workflows.v1.ParseResult.
 * Use `create(ParseResultSchema)` to create a new message.
 */
export const ParseResultSchema: GenMessage<ParseResult, { jsonType: ParseResultJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 16);

/**
 * @generated from message workflows.v1.SplitParams
 */
export type SplitParams = Message<"workflows.v1.SplitParams"> & {
	/**
	 * @generated from field: workflows.v1.ParseParams parse_params = 1;
	 */
	parseParams?: ParseParams | undefined;

	/**
	 * @generated from field: workflows.v1.Splitter splitter = 2;
	 */
	splitter?: Splitter | undefined;
};

/**
 * @generated from message workflows.v1.SplitParams
 */
export type SplitParamsJson = {
	/**
	 * @generated from field: workflows.v1.ParseParams parse_params = 1;
	 */
	parseParams?: ParseParamsJson;

	/**
	 * @generated from field: workflows.v1.Splitter splitter = 2;
	 */
	splitter?: SplitterJson;
};

/**
 * Describes the message workflows.v1.SplitParams.
 * Use `create(SplitParamsSchema)` to create a new message.
 */
export const SplitParamsSchema: GenMessage<SplitParams, { jsonType: SplitParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 17);

/**
 * @generated from message workflows.v1.SplitResult
 */
export type SplitResult = Message<"workflows.v1.SplitResult"> & {
	/**
	 * @generated from field: repeated workflows.v1.LoadResult payloads = 1;
	 */
	payloads: LoadResult[];
};

/**
 * @generated from message workflows.v1.SplitResult
 */
export type SplitResultJson = {
	/**
	 * @generated from field: repeated workflows.v1.LoadResult payloads = 1;
	 */
	payloads?: LoadResultJson[];
};

/**
 * Describes the message workflows.v1.SplitResult.
 * Use `create(SplitResultSchema)` to create a new message.
 */
export const SplitResultSchema: GenMessage<SplitResult, { jsonType: SplitResultJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 18);

/**
 * @generated from message workflows.v1.TimestampOptions
 */
export type TimestampOptions = Message<"workflows.v1.TimestampOptions"> & {
	/**
	 * @generated from field: string path = 1;
	 */
	path: string;

	/**
	 * @generated from field: string format = 2;
	 */
	format: string;
};

/**
 * @generated from message workflows.v1.TimestampOptions
 */
export type TimestampOptionsJson = {
	/**
	 * @generated from field: string path = 1;
	 */
	path?: string;

	/**
	 * @generated from field: string format = 2;
	 */
	format?: string;
};

/**
 * Describes the message workflows.v1.TimestampOptions.
 * Use `create(TimestampOptionsSchema)` to create a new message.
 */
export const TimestampOptionsSchema: GenMessage<TimestampOptions, { jsonType: TimestampOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 19);

/**
 * @generated from message workflows.v1.MoneyOptions
 */
export type MoneyOptions = Message<"workflows.v1.MoneyOptions"> & {
	/**
	 * @generated from field: string currency = 1;
	 */
	currency: string;
};

/**
 * @generated from message workflows.v1.MoneyOptions
 */
export type MoneyOptionsJson = {
	/**
	 * @generated from field: string currency = 1;
	 */
	currency?: string;
};

/**
 * Describes the message workflows.v1.MoneyOptions.
 * Use `create(MoneyOptionsSchema)` to create a new message.
 */
export const MoneyOptionsSchema: GenMessage<MoneyOptions, { jsonType: MoneyOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 20);

/**
 * @generated from message workflows.v1.PhoneOptions
 */
export type PhoneOptions = Message<"workflows.v1.PhoneOptions"> & {
	/**
	 * @generated from field: string country = 1;
	 */
	country: string;
};

/**
 * @generated from message workflows.v1.PhoneOptions
 */
export type PhoneOptionsJson = {
	/**
	 * @generated from field: string country = 1;
	 */
	country?: string;
};

/**
 * Describes the message workflows.v1.PhoneOptions.
 * Use `create(PhoneOptionsSchema)` to create a new message.
 */
export const PhoneOptionsSchema: GenMessage<PhoneOptions, { jsonType: PhoneOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 21);

/**
 * @generated from message workflows.v1.TextOptions
 */
export type TextOptions = Message<"workflows.v1.TextOptions"> & {
	/**
	 * @generated from field: repeated workflows.v1.TextTransform transforms = 1;
	 */
	transforms: TextTransform[];
};

/**
 * @generated from message workflows.v1.TextOptions
 */
export type TextOptionsJson = {
	/**
	 * @generated from field: repeated workflows.v1.TextTransform transforms = 1;
	 */
	transforms?: TextTransformJson[];
};

/**
 * Describes the message workflows.v1.TextOptions.
 * Use `create(TextOptionsSchema)` to create a new message.
 */
export const TextOptionsSchema: GenMessage<TextOptions, { jsonType: TextOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 22);

/**
 * @generated from message workflows.v1.TextTransform
 */
export type TextTransform = Message<"workflows.v1.TextTransform"> & {
	/**
	 * @generated from oneof workflows.v1.TextTransform.transform
	 */
	transform:
		| {
				/**
				 * @generated from field: workflows.v1.PrefixTransform prefix = 1;
				 */
				value: PrefixTransform;
				case: "prefix";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.NullIfTransform null_if = 2;
				 */
				value: NullIfTransform;
				case: "nullIf";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.SpliceTransform splice = 3;
				 */
				value: SpliceTransform;
				case: "splice";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.TextTransform
 */
export type TextTransformJson = {
	/**
	 * @generated from field: workflows.v1.PrefixTransform prefix = 1;
	 */
	prefix?: PrefixTransformJson;

	/**
	 * @generated from field: workflows.v1.NullIfTransform null_if = 2;
	 */
	nullIf?: NullIfTransformJson;

	/**
	 * @generated from field: workflows.v1.SpliceTransform splice = 3;
	 */
	splice?: SpliceTransformJson;
};

/**
 * Describes the message workflows.v1.TextTransform.
 * Use `create(TextTransformSchema)` to create a new message.
 */
export const TextTransformSchema: GenMessage<TextTransform, { jsonType: TextTransformJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 23);

/**
 * @generated from message workflows.v1.ArrayTransform
 */
export type ArrayTransform = Message<"workflows.v1.ArrayTransform"> & {
	/**
	 * @generated from oneof workflows.v1.ArrayTransform.transform
	 */
	transform:
		| {
				/**
				 * @generated from field: workflows.v1.SortTransform sort_by = 1;
				 */
				value: SortTransform;
				case: "sortBy";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.FilterTransform filter = 2;
				 */
				value: FilterTransform;
				case: "filter";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.ArrayTransform
 */
export type ArrayTransformJson = {
	/**
	 * @generated from field: workflows.v1.SortTransform sort_by = 1;
	 */
	sortBy?: SortTransformJson;

	/**
	 * @generated from field: workflows.v1.FilterTransform filter = 2;
	 */
	filter?: FilterTransformJson;
};

/**
 * Describes the message workflows.v1.ArrayTransform.
 * Use `create(ArrayTransformSchema)` to create a new message.
 */
export const ArrayTransformSchema: GenMessage<ArrayTransform, { jsonType: ArrayTransformJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 24);

/**
 * @generated from message workflows.v1.SortTransform
 */
export type SortTransform = Message<"workflows.v1.SortTransform"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;
};

/**
 * @generated from message workflows.v1.SortTransform
 */
export type SortTransformJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;
};

/**
 * Describes the message workflows.v1.SortTransform.
 * Use `create(SortTransformSchema)` to create a new message.
 */
export const SortTransformSchema: GenMessage<SortTransform, { jsonType: SortTransformJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 25);

/**
 * @generated from message workflows.v1.FilterTransform
 */
export type FilterTransform = Message<"workflows.v1.FilterTransform"> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value: string;
};

/**
 * @generated from message workflows.v1.FilterTransform
 */
export type FilterTransformJson = {
	/**
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * @generated from field: string value = 2;
	 */
	value?: string;
};

/**
 * Describes the message workflows.v1.FilterTransform.
 * Use `create(FilterTransformSchema)` to create a new message.
 */
export const FilterTransformSchema: GenMessage<FilterTransform, { jsonType: FilterTransformJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 26);

/**
 * @generated from message workflows.v1.PrefixTransform
 */
export type PrefixTransform = Message<"workflows.v1.PrefixTransform"> & {
	/**
	 * @generated from field: string prefix = 1;
	 */
	prefix: string;
};

/**
 * @generated from message workflows.v1.PrefixTransform
 */
export type PrefixTransformJson = {
	/**
	 * @generated from field: string prefix = 1;
	 */
	prefix?: string;
};

/**
 * Describes the message workflows.v1.PrefixTransform.
 * Use `create(PrefixTransformSchema)` to create a new message.
 */
export const PrefixTransformSchema: GenMessage<PrefixTransform, { jsonType: PrefixTransformJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 27);

/**
 * @generated from message workflows.v1.NullIfTransform
 */
export type NullIfTransform = Message<"workflows.v1.NullIfTransform"> & {
	/**
	 * @generated from field: string value = 1;
	 */
	value: string;
};

/**
 * @generated from message workflows.v1.NullIfTransform
 */
export type NullIfTransformJson = {
	/**
	 * @generated from field: string value = 1;
	 */
	value?: string;
};

/**
 * Describes the message workflows.v1.NullIfTransform.
 * Use `create(NullIfTransformSchema)` to create a new message.
 */
export const NullIfTransformSchema: GenMessage<NullIfTransform, { jsonType: NullIfTransformJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 28);

/**
 * @generated from message workflows.v1.SpliceTransform
 */
export type SpliceTransform = Message<"workflows.v1.SpliceTransform"> & {
	/**
	 * @generated from field: string delimeter = 1;
	 */
	delimeter: string;

	/**
	 * @generated from oneof workflows.v1.SpliceTransform.indexer
	 */
	indexer:
		| {
				/**
				 * @generated from field: int32 index = 2;
				 */
				value: number;
				case: "index";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.Slice slice = 3;
				 */
				value: Slice;
				case: "slice";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.SpliceTransform
 */
export type SpliceTransformJson = {
	/**
	 * @generated from field: string delimeter = 1;
	 */
	delimeter?: string;

	/**
	 * @generated from field: int32 index = 2;
	 */
	index?: number;

	/**
	 * @generated from field: workflows.v1.Slice slice = 3;
	 */
	slice?: SliceJson;
};

/**
 * Describes the message workflows.v1.SpliceTransform.
 * Use `create(SpliceTransformSchema)` to create a new message.
 */
export const SpliceTransformSchema: GenMessage<SpliceTransform, { jsonType: SpliceTransformJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 29);

/**
 * @generated from message workflows.v1.Slice
 */
export type Slice = Message<"workflows.v1.Slice"> & {
	/**
	 * @generated from field: string joiner = 1;
	 */
	joiner: string;

	/**
	 * @generated from field: optional int32 low = 2;
	 */
	low?: number | undefined;

	/**
	 * @generated from field: optional int32 high = 3;
	 */
	high?: number | undefined;
};

/**
 * @generated from message workflows.v1.Slice
 */
export type SliceJson = {
	/**
	 * @generated from field: string joiner = 1;
	 */
	joiner?: string;

	/**
	 * @generated from field: optional int32 low = 2;
	 */
	low?: number;

	/**
	 * @generated from field: optional int32 high = 3;
	 */
	high?: number;
};

/**
 * Describes the message workflows.v1.Slice.
 * Use `create(SliceSchema)` to create a new message.
 */
export const SliceSchema: GenMessage<Slice, { jsonType: SliceJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 30);

/**
 * @generated from message workflows.v1.MappedValue
 */
export type MappedValue = Message<"workflows.v1.MappedValue"> & {
	/**
	 * @generated from field: string value = 1;
	 */
	value: string;

	/**
	 * used if value is undefined
	 *
	 * @generated from field: string default = 5;
	 */
	default: string;

	/**
	 * @generated from field: repeated workflows.v1.TextTransform text_transforms = 7;
	 */
	textTransforms: TextTransform[];

	/**
	 * @generated from field: repeated workflows.v1.ArrayTransform array_transforms = 8;
	 */
	arrayTransforms: ArrayTransform[];

	/**
	 * @generated from oneof workflows.v1.MappedValue.options
	 */
	options:
		| {
				/**
				 * @generated from field: workflows.v1.TimestampOptions timestamp = 2;
				 */
				value: TimestampOptions;
				case: "timestamp";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.MoneyOptions money = 3;
				 */
				value: MoneyOptions;
				case: "money";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.PhoneOptions phone = 4;
				 */
				value: PhoneOptions;
				case: "phone";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.TextOptions text = 6;
				 */
				value: TextOptions;
				case: "text";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.MappedValue
 */
export type MappedValueJson = {
	/**
	 * @generated from field: string value = 1;
	 */
	value?: string;

	/**
	 * used if value is undefined
	 *
	 * @generated from field: string default = 5;
	 */
	default?: string;

	/**
	 * @generated from field: repeated workflows.v1.TextTransform text_transforms = 7;
	 */
	textTransforms?: TextTransformJson[];

	/**
	 * @generated from field: repeated workflows.v1.ArrayTransform array_transforms = 8;
	 */
	arrayTransforms?: ArrayTransformJson[];

	/**
	 * @generated from field: workflows.v1.TimestampOptions timestamp = 2;
	 */
	timestamp?: TimestampOptionsJson;

	/**
	 * @generated from field: workflows.v1.MoneyOptions money = 3;
	 */
	money?: MoneyOptionsJson;

	/**
	 * @generated from field: workflows.v1.PhoneOptions phone = 4;
	 */
	phone?: PhoneOptionsJson;

	/**
	 * @generated from field: workflows.v1.TextOptions text = 6;
	 */
	text?: TextOptionsJson;
};

/**
 * Describes the message workflows.v1.MappedValue.
 * Use `create(MappedValueSchema)` to create a new message.
 */
export const MappedValueSchema: GenMessage<MappedValue, { jsonType: MappedValueJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 31);

/**
 * @generated from message workflows.v1.MapperOptions
 */
export type MapperOptions = Message<"workflows.v1.MapperOptions"> & {
	/**
	 * @generated from field: bool trim_arrays = 1;
	 */
	trimArrays: boolean;
};

/**
 * @generated from message workflows.v1.MapperOptions
 */
export type MapperOptionsJson = {
	/**
	 * @generated from field: bool trim_arrays = 1;
	 */
	trimArrays?: boolean;
};

/**
 * Describes the message workflows.v1.MapperOptions.
 * Use `create(MapperOptionsSchema)` to create a new message.
 */
export const MapperOptionsSchema: GenMessage<MapperOptions, { jsonType: MapperOptionsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 32);

/**
 * @generated from message workflows.v1.Mapper
 */
export type Mapper = Message<"workflows.v1.Mapper"> & {
	/**
	 * @generated from field: map<string, string> context_mapping = 1;
	 */
	contextMapping: { [key: string]: string };

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 2;
	 */
	mapping: { [key: string]: MappedValue };

	/**
	 * @generated from field: int32 batch_size = 3;
	 */
	batchSize: number;

	/**
	 * @generated from field: workflows.v1.MapperOptions options = 4;
	 */
	options?: MapperOptions | undefined;
};

/**
 * @generated from message workflows.v1.Mapper
 */
export type MapperJson = {
	/**
	 * @generated from field: map<string, string> context_mapping = 1;
	 */
	contextMapping?: { [key: string]: string };

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 2;
	 */
	mapping?: { [key: string]: MappedValueJson };

	/**
	 * @generated from field: int32 batch_size = 3;
	 */
	batchSize?: number;

	/**
	 * @generated from field: workflows.v1.MapperOptions options = 4;
	 */
	options?: MapperOptionsJson;
};

/**
 * Describes the message workflows.v1.Mapper.
 * Use `create(MapperSchema)` to create a new message.
 */
export const MapperSchema: GenMessage<Mapper, { jsonType: MapperJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 33);

/**
 * @generated from message workflows.v1.WorkflowDefinition
 */
export type WorkflowDefinition = Message<"workflows.v1.WorkflowDefinition"> & {
	/**
	 * @generated from field: workflows.v1.Loader loader = 1;
	 */
	loader?: Loader | undefined;

	/**
	 * @generated from field: workflows.v1.Splitter splitter = 5;
	 */
	splitter?: Splitter | undefined;

	/**
	 * @generated from field: workflows.v1.Parser parser = 2;
	 */
	parser?: Parser | undefined;

	/**
	 * @generated from field: workflows.v1.Mapper mapper = 3;
	 */
	mapper?: Mapper | undefined;

	/**
	 * @generated from field: repeated workflows.v1.WorkflowDefinition children = 4;
	 */
	children: WorkflowDefinition[];
};

/**
 * @generated from message workflows.v1.WorkflowDefinition
 */
export type WorkflowDefinitionJson = {
	/**
	 * @generated from field: workflows.v1.Loader loader = 1;
	 */
	loader?: LoaderJson;

	/**
	 * @generated from field: workflows.v1.Splitter splitter = 5;
	 */
	splitter?: SplitterJson;

	/**
	 * @generated from field: workflows.v1.Parser parser = 2;
	 */
	parser?: ParserJson;

	/**
	 * @generated from field: workflows.v1.Mapper mapper = 3;
	 */
	mapper?: MapperJson;

	/**
	 * @generated from field: repeated workflows.v1.WorkflowDefinition children = 4;
	 */
	children?: WorkflowDefinitionJson[];
};

/**
 * Describes the message workflows.v1.WorkflowDefinition.
 * Use `create(WorkflowDefinitionSchema)` to create a new message.
 */
export const WorkflowDefinitionSchema: GenMessage<WorkflowDefinition, { jsonType: WorkflowDefinitionJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 34);

/**
 * @generated from message workflows.v1.AssetDestination
 */
export type AssetDestination = Message<"workflows.v1.AssetDestination"> & {
	/**
	 * @generated from oneof workflows.v1.AssetDestination.asset_destination
	 */
	assetDestination:
		| {
				/**
				 * @generated from field: string personal_workspace = 1;
				 */
				value: string;
				case: "personalWorkspace";
		  }
		| {
				/**
				 * @generated from field: string workspace_id = 2;
				 */
				value: string;
				case: "workspaceId";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.AssetDestination
 */
export type AssetDestinationJson = {
	/**
	 * @generated from field: string personal_workspace = 1;
	 */
	personalWorkspace?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message workflows.v1.AssetDestination.
 * Use `create(AssetDestinationSchema)` to create a new message.
 */
export const AssetDestinationSchema: GenMessage<AssetDestination, { jsonType: AssetDestinationJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 35);

/**
 * Params for the entrypoint workflow
 *
 * @generated from message workflows.v1.ExecParams
 */
export type ExecParams = Message<"workflows.v1.ExecParams"> & {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: Workflow | undefined;

	/**
	 * @generated from field: workflows.v1.LoadResult load_result = 2;
	 */
	loadResult?: LoadResult | undefined;

	/**
	 * @generated from field: workflows.v1.SplitResult split_result = 3;
	 */
	splitResult?: SplitResult | undefined;
};

/**
 * Params for the entrypoint workflow
 *
 * @generated from message workflows.v1.ExecParams
 */
export type ExecParamsJson = {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: WorkflowJson;

	/**
	 * @generated from field: workflows.v1.LoadResult load_result = 2;
	 */
	loadResult?: LoadResultJson;

	/**
	 * @generated from field: workflows.v1.SplitResult split_result = 3;
	 */
	splitResult?: SplitResultJson;
};

/**
 * Describes the message workflows.v1.ExecParams.
 * Use `create(ExecParamsSchema)` to create a new message.
 */
export const ExecParamsSchema: GenMessage<ExecParams, { jsonType: ExecParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 36);

/**
 * @generated from message workflows.v1.ParseWorkflowParams
 */
export type ParseWorkflowParams = Message<"workflows.v1.ParseWorkflowParams"> & {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: Workflow | undefined;

	/**
	 * @generated from field: workflows.v1.LoadResult load = 2;
	 */
	load?: LoadResult | undefined;
};

/**
 * @generated from message workflows.v1.ParseWorkflowParams
 */
export type ParseWorkflowParamsJson = {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: WorkflowJson;

	/**
	 * @generated from field: workflows.v1.LoadResult load = 2;
	 */
	load?: LoadResultJson;
};

/**
 * Describes the message workflows.v1.ParseWorkflowParams.
 * Use `create(ParseWorkflowParamsSchema)` to create a new message.
 */
export const ParseWorkflowParamsSchema: GenMessage<ParseWorkflowParams, { jsonType: ParseWorkflowParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 37);

/**
 * @generated from message workflows.v1.TransformParams
 */
export type TransformParams = Message<"workflows.v1.TransformParams"> & {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: Workflow | undefined;

	/**
	 * @generated from field: google.protobuf.Value data = 2;
	 */
	data?: Value | undefined;
};

/**
 * @generated from message workflows.v1.TransformParams
 */
export type TransformParamsJson = {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: WorkflowJson;

	/**
	 * @generated from field: google.protobuf.Value data = 2;
	 */
	data?: ValueJson;
};

/**
 * Describes the message workflows.v1.TransformParams.
 * Use `create(TransformParamsSchema)` to create a new message.
 */
export const TransformParamsSchema: GenMessage<TransformParams, { jsonType: TransformParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 38);

/**
 * @generated from message workflows.v1.TransformAndEmitParams
 */
export type TransformAndEmitParams = Message<"workflows.v1.TransformAndEmitParams"> & {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: Workflow | undefined;

	/**
	 * @generated from field: repeated google.protobuf.Value data = 2;
	 */
	data: Value[];

	/**
	 * @generated from field: int32 batch_size = 3;
	 */
	batchSize: number;
};

/**
 * @generated from message workflows.v1.TransformAndEmitParams
 */
export type TransformAndEmitParamsJson = {
	/**
	 * @generated from field: workflows.v1.Workflow workflow = 1;
	 */
	workflow?: WorkflowJson;

	/**
	 * @generated from field: repeated google.protobuf.Value data = 2;
	 */
	data?: ValueJson[];

	/**
	 * @generated from field: int32 batch_size = 3;
	 */
	batchSize?: number;
};

/**
 * Describes the message workflows.v1.TransformAndEmitParams.
 * Use `create(TransformAndEmitParamsSchema)` to create a new message.
 */
export const TransformAndEmitParamsSchema: GenMessage<TransformAndEmitParams, { jsonType: TransformAndEmitParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 39);

/**
 * @generated from message workflows.v1.TransformResult
 */
export type TransformResult = Message<"workflows.v1.TransformResult"> & {
	/**
	 * @generated from field: google.protobuf.Any created = 1;
	 */
	created?: Any | undefined;
};

/**
 * @generated from message workflows.v1.TransformResult
 */
export type TransformResultJson = {
	/**
	 * @generated from field: google.protobuf.Any created = 1;
	 */
	created?: AnyJson;
};

/**
 * Describes the message workflows.v1.TransformResult.
 * Use `create(TransformResultSchema)` to create a new message.
 */
export const TransformResultSchema: GenMessage<TransformResult, { jsonType: TransformResultJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 40);

/**
 * @generated from message workflows.v1.LoadParams
 */
export type LoadParams = Message<"workflows.v1.LoadParams"> & {
	/**
	 * @generated from field: google.protobuf.Struct context = 1;
	 */
	context?: JsonObject | undefined;

	/**
	 * @generated from field: workflows.v1.Loader loader = 2;
	 */
	loader?: Loader | undefined;
};

/**
 * @generated from message workflows.v1.LoadParams
 */
export type LoadParamsJson = {
	/**
	 * @generated from field: google.protobuf.Struct context = 1;
	 */
	context?: StructJson;

	/**
	 * @generated from field: workflows.v1.Loader loader = 2;
	 */
	loader?: LoaderJson;
};

/**
 * Describes the message workflows.v1.LoadParams.
 * Use `create(LoadParamsSchema)` to create a new message.
 */
export const LoadParamsSchema: GenMessage<LoadParams, { jsonType: LoadParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 41);

/**
 * @generated from message workflows.v1.LoadResult
 */
export type LoadResult = Message<"workflows.v1.LoadResult"> & {
	/**
	 * @generated from oneof workflows.v1.LoadResult.result
	 */
	result:
		| {
				/**
				 * @generated from field: bytes data = 1;
				 */
				value: Uint8Array;
				case: "data";
		  }
		| {
				/**
				 * @generated from field: workflows.v1.S3Object s3_object = 3;
				 */
				value: S3Object;
				case: "s3Object";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.LoadResult
 */
export type LoadResultJson = {
	/**
	 * @generated from field: bytes data = 1;
	 */
	data?: string;

	/**
	 * @generated from field: workflows.v1.S3Object s3_object = 3;
	 */
	s3Object?: S3ObjectJson;
};

/**
 * Describes the message workflows.v1.LoadResult.
 * Use `create(LoadResultSchema)` to create a new message.
 */
export const LoadResultSchema: GenMessage<LoadResult, { jsonType: LoadResultJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 42);

/**
 * @generated from message workflows.v1.MapParams
 */
export type MapParams = Message<"workflows.v1.MapParams"> & {
	/**
	 * @generated from field: google.protobuf.Struct context = 1;
	 */
	context?: JsonObject | undefined;

	/**
	 * @generated from field: workflows.v1.Mapper mapper = 2;
	 */
	mapper?: Mapper | undefined;

	/**
	 * @generated from field: google.protobuf.Struct parse = 3;
	 */
	parse?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Any draft = 4;
	 */
	draft?: Any | undefined;
};

/**
 * @generated from message workflows.v1.MapParams
 */
export type MapParamsJson = {
	/**
	 * @generated from field: google.protobuf.Struct context = 1;
	 */
	context?: StructJson;

	/**
	 * @generated from field: workflows.v1.Mapper mapper = 2;
	 */
	mapper?: MapperJson;

	/**
	 * @generated from field: google.protobuf.Struct parse = 3;
	 */
	parse?: StructJson;

	/**
	 * @generated from field: google.protobuf.Any draft = 4;
	 */
	draft?: AnyJson;
};

/**
 * Describes the message workflows.v1.MapParams.
 * Use `create(MapParamsSchema)` to create a new message.
 */
export const MapParamsSchema: GenMessage<MapParams, { jsonType: MapParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 43);

/**
 * @generated from message workflows.v1.MapResult
 */
export type MapResult = Message<"workflows.v1.MapResult"> & {
	/**
	 * @generated from field: google.protobuf.Struct context = 2;
	 */
	context?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Any artifact = 1;
	 */
	artifact?: Any | undefined;
};

/**
 * @generated from message workflows.v1.MapResult
 */
export type MapResultJson = {
	/**
	 * @generated from field: google.protobuf.Struct context = 2;
	 */
	context?: StructJson;

	/**
	 * @generated from field: google.protobuf.Any artifact = 1;
	 */
	artifact?: AnyJson;
};

/**
 * Describes the message workflows.v1.MapResult.
 * Use `create(MapResultSchema)` to create a new message.
 */
export const MapResultSchema: GenMessage<MapResult, { jsonType: MapResultJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 44);

/**
 * @generated from message workflows.v1.EmitParams
 */
export type EmitParams = Message<"workflows.v1.EmitParams"> & {
	/**
	 * @generated from field: google.protobuf.Any artifact = 1;
	 */
	artifact?: Any | undefined;

	/**
	 * @generated from field: repeated google.protobuf.Any artifacts = 2;
	 */
	artifacts: Any[];

	/**
	 * @generated from field: workflows.v1.AssetDestination destination = 5;
	 */
	destination?: AssetDestination | undefined;

	/**
	 * @generated from field: google.protobuf.Struct context = 6;
	 */
	context?: JsonObject | undefined;

	/**
	 * @generated from field: common.v1.Creator creator = 4;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: int32 batch_size = 3;
	 */
	batchSize: number;
};

/**
 * @generated from message workflows.v1.EmitParams
 */
export type EmitParamsJson = {
	/**
	 * @generated from field: google.protobuf.Any artifact = 1;
	 */
	artifact?: AnyJson;

	/**
	 * @generated from field: repeated google.protobuf.Any artifacts = 2;
	 */
	artifacts?: AnyJson[];

	/**
	 * @generated from field: workflows.v1.AssetDestination destination = 5;
	 */
	destination?: AssetDestinationJson;

	/**
	 * @generated from field: google.protobuf.Struct context = 6;
	 */
	context?: StructJson;

	/**
	 * @generated from field: common.v1.Creator creator = 4;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: int32 batch_size = 3;
	 */
	batchSize?: number;
};

/**
 * Describes the message workflows.v1.EmitParams.
 * Use `create(EmitParamsSchema)` to create a new message.
 */
export const EmitParamsSchema: GenMessage<EmitParams, { jsonType: EmitParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 45);

/**
 * @generated from message workflows.v1.EmitResult
 */
export type EmitResult = Message<"workflows.v1.EmitResult"> & {
	/**
	 * @generated from field: google.protobuf.Any created = 1;
	 */
	created?: Any | undefined;
};

/**
 * @generated from message workflows.v1.EmitResult
 */
export type EmitResultJson = {
	/**
	 * @generated from field: google.protobuf.Any created = 1;
	 */
	created?: AnyJson;
};

/**
 * Describes the message workflows.v1.EmitResult.
 * Use `create(EmitResultSchema)` to create a new message.
 */
export const EmitResultSchema: GenMessage<EmitResult, { jsonType: EmitResultJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 46);

/**
 * @generated from message workflows.v1.EmitManyResult
 */
export type EmitManyResult = Message<"workflows.v1.EmitManyResult"> & {
	/**
	 * @generated from field: repeated workflows.v1.EmitResult created = 1;
	 */
	created: EmitResult[];

	/**
	 * @generated from field: int64 num_created = 2;
	 */
	numCreated: bigint;
};

/**
 * @generated from message workflows.v1.EmitManyResult
 */
export type EmitManyResultJson = {
	/**
	 * @generated from field: repeated workflows.v1.EmitResult created = 1;
	 */
	created?: EmitResultJson[];

	/**
	 * @generated from field: int64 num_created = 2;
	 */
	numCreated?: string;
};

/**
 * Describes the message workflows.v1.EmitManyResult.
 * Use `create(EmitManyResultSchema)` to create a new message.
 */
export const EmitManyResultSchema: GenMessage<EmitManyResult, { jsonType: EmitManyResultJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 47);

/**
 * @generated from message workflows.v1.Interval
 */
export type Interval = Message<"workflows.v1.Interval"> & {
	/**
	 * @generated from field: google.protobuf.Duration every = 1;
	 */
	every?: Duration | undefined;

	/**
	 * @generated from field: google.protobuf.Duration offset = 2;
	 */
	offset?: Duration | undefined;
};

/**
 * @generated from message workflows.v1.Interval
 */
export type IntervalJson = {
	/**
	 * @generated from field: google.protobuf.Duration every = 1;
	 */
	every?: DurationJson;

	/**
	 * @generated from field: google.protobuf.Duration offset = 2;
	 */
	offset?: DurationJson;
};

/**
 * Describes the message workflows.v1.Interval.
 * Use `create(IntervalSchema)` to create a new message.
 */
export const IntervalSchema: GenMessage<Interval, { jsonType: IntervalJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 48);

/**
 * @generated from message workflows.v1.Recurrence
 */
export type Recurrence = Message<"workflows.v1.Recurrence"> & {
	/**
	 * @generated from field: workflows.v1.Interval interval = 1 [deprecated = true];
	 * @deprecated
	 */
	interval?: Interval | undefined;

	/**
	 * @generated from field: repeated workflows.v1.Interval intervals = 2;
	 */
	intervals: Interval[];

	/**
	 * @generated from field: google.protobuf.Duration jitter = 3;
	 */
	jitter?: Duration | undefined;
};

/**
 * @generated from message workflows.v1.Recurrence
 */
export type RecurrenceJson = {
	/**
	 * @generated from field: workflows.v1.Interval interval = 1 [deprecated = true];
	 * @deprecated
	 */
	interval?: IntervalJson;

	/**
	 * @generated from field: repeated workflows.v1.Interval intervals = 2;
	 */
	intervals?: IntervalJson[];

	/**
	 * @generated from field: google.protobuf.Duration jitter = 3;
	 */
	jitter?: DurationJson;
};

/**
 * Describes the message workflows.v1.Recurrence.
 * Use `create(RecurrenceSchema)` to create a new message.
 */
export const RecurrenceSchema: GenMessage<Recurrence, { jsonType: RecurrenceJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 49);

/**
 * @generated from message workflows.v1.Workflow
 */
export type Workflow = Message<"workflows.v1.Workflow"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 11;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: repeated workflows.v1.Trigger triggers = 5;
	 */
	triggers: Trigger[];

	/**
	 * @generated from field: workflows.v1.WorkflowDefinition definition = 6;
	 */
	definition?: WorkflowDefinition | undefined;

	/**
	 * @generated from field: google.protobuf.Struct context = 7;
	 */
	context?: JsonObject | undefined;

	/**
	 * @generated from field: google.protobuf.Any draft = 8;
	 */
	draft?: Any | undefined;

	/**
	 * @generated from field: workflows.v1.Recurrence recurrence = 9;
	 */
	recurrence?: Recurrence | undefined;

	/**
	 * @generated from field: workflows.v1.AssetDestination asset_destination = 10;
	 */
	assetDestination?: AssetDestination | undefined;

	/**
	 * @generated from field: notifications.v2.Notification summary_notification = 12;
	 */
	summaryNotification?: Notification | undefined;
};

/**
 * @generated from message workflows.v1.Workflow
 */
export type WorkflowJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 3;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 11;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: repeated workflows.v1.Trigger triggers = 5;
	 */
	triggers?: TriggerJson[];

	/**
	 * @generated from field: workflows.v1.WorkflowDefinition definition = 6;
	 */
	definition?: WorkflowDefinitionJson;

	/**
	 * @generated from field: google.protobuf.Struct context = 7;
	 */
	context?: StructJson;

	/**
	 * @generated from field: google.protobuf.Any draft = 8;
	 */
	draft?: AnyJson;

	/**
	 * @generated from field: workflows.v1.Recurrence recurrence = 9;
	 */
	recurrence?: RecurrenceJson;

	/**
	 * @generated from field: workflows.v1.AssetDestination asset_destination = 10;
	 */
	assetDestination?: AssetDestinationJson;

	/**
	 * @generated from field: notifications.v2.Notification summary_notification = 12;
	 */
	summaryNotification?: NotificationJson;
};

/**
 * Describes the message workflows.v1.Workflow.
 * Use `create(WorkflowSchema)` to create a new message.
 */
export const WorkflowSchema: GenMessage<Workflow, { jsonType: WorkflowJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 50);

/**
 * @generated from message workflows.v1.Trigger
 */
export type Trigger = Message<"workflows.v1.Trigger"> & {
	/**
	 * @generated from oneof workflows.v1.Trigger.trigger
	 */
	trigger:
		| {
				/**
				 * @generated from field: workflows.v1.EventTrigger event = 1;
				 */
				value: EventTrigger;
				case: "event";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message workflows.v1.Trigger
 */
export type TriggerJson = {
	/**
	 * @generated from field: workflows.v1.EventTrigger event = 1;
	 */
	event?: EventTriggerJson;
};

/**
 * Describes the message workflows.v1.Trigger.
 * Use `create(TriggerSchema)` to create a new message.
 */
export const TriggerSchema: GenMessage<Trigger, { jsonType: TriggerJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 51);

/**
 * @generated from message workflows.v1.EventTrigger
 */
export type EventTrigger = Message<"workflows.v1.EventTrigger"> & {
	/**
	 * @generated from field: string topic = 1;
	 */
	topic: string;
};

/**
 * @generated from message workflows.v1.EventTrigger
 */
export type EventTriggerJson = {
	/**
	 * @generated from field: string topic = 1;
	 */
	topic?: string;
};

/**
 * Describes the message workflows.v1.EventTrigger.
 * Use `create(EventTriggerSchema)` to create a new message.
 */
export const EventTriggerSchema: GenMessage<EventTrigger, { jsonType: EventTriggerJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 52);

/**
 * @generated from message workflows.v1.ReportWorkflowRunStartedParams
 */
export type ReportWorkflowRunStartedParams = Message<"workflows.v1.ReportWorkflowRunStartedParams"> & {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId: string;

	/**
	 * @generated from field: workflows.v1.Workflow workflow = 2;
	 */
	workflow?: Workflow | undefined;
};

/**
 * @generated from message workflows.v1.ReportWorkflowRunStartedParams
 */
export type ReportWorkflowRunStartedParamsJson = {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId?: string;

	/**
	 * @generated from field: workflows.v1.Workflow workflow = 2;
	 */
	workflow?: WorkflowJson;
};

/**
 * Describes the message workflows.v1.ReportWorkflowRunStartedParams.
 * Use `create(ReportWorkflowRunStartedParamsSchema)` to create a new message.
 */
export const ReportWorkflowRunStartedParamsSchema: GenMessage<ReportWorkflowRunStartedParams, { jsonType: ReportWorkflowRunStartedParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 53);

/**
 * @generated from message workflows.v1.ReportWorkflowStepCompletedParams
 */
export type ReportWorkflowStepCompletedParams = Message<"workflows.v1.ReportWorkflowStepCompletedParams"> & {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId: string;

	/**
	 * @generated from field: workflows.v1.Workflow workflow = 2;
	 */
	workflow?: Workflow | undefined;

	/**
	 * @generated from field: google.protobuf.Value input = 3;
	 */
	input?: Value | undefined;

	/**
	 * @generated from field: google.rpc.Status error = 4;
	 */
	error?: Status | undefined;
};

/**
 * @generated from message workflows.v1.ReportWorkflowStepCompletedParams
 */
export type ReportWorkflowStepCompletedParamsJson = {
	/**
	 * @generated from field: string run_id = 1;
	 */
	runId?: string;

	/**
	 * @generated from field: workflows.v1.Workflow workflow = 2;
	 */
	workflow?: WorkflowJson;

	/**
	 * @generated from field: google.protobuf.Value input = 3;
	 */
	input?: ValueJson;

	/**
	 * @generated from field: google.rpc.Status error = 4;
	 */
	error?: StatusJson;
};

/**
 * Describes the message workflows.v1.ReportWorkflowStepCompletedParams.
 * Use `create(ReportWorkflowStepCompletedParamsSchema)` to create a new message.
 */
export const ReportWorkflowStepCompletedParamsSchema: GenMessage<ReportWorkflowStepCompletedParams, { jsonType: ReportWorkflowStepCompletedParamsJson }> = /*@__PURE__*/ messageDesc(file_workflows_v1_workflows, 54);

/**
 * @generated from enum workflows.v1.AuthType
 */
export enum AuthType {
	/**
	 * @generated from enum value: AUTH_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: AUTH_TYPE_CLIENT_CREDENTIALS = 1;
	 */
	CLIENT_CREDENTIALS = 1,

	/**
	 * @generated from enum value: AUTH_TYPE_API_KEY = 2;
	 */
	API_KEY = 2,

	/**
	 * use go-frontegg and env service creds
	 *
	 * @generated from enum value: AUTH_TYPE_FC = 3;
	 */
	FC = 3,
}

/**
 * @generated from enum workflows.v1.AuthType
 */
export type AuthTypeJson = "AUTH_TYPE_UNSPECIFIED" | "AUTH_TYPE_CLIENT_CREDENTIALS" | "AUTH_TYPE_API_KEY" | "AUTH_TYPE_FC";

/**
 * Describes the enum workflows.v1.AuthType.
 */
export const AuthTypeSchema: GenEnum<AuthType, AuthTypeJson> = /*@__PURE__*/ enumDesc(file_workflows_v1_workflows, 0);

/**
 * @generated from enum workflows.v1.ParserFormat
 */
export enum ParserFormat {
	/**
	 * @generated from enum value: PARSER_FORMAT_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PARSER_FORMAT_JSON = 1;
	 */
	JSON = 1,

	/**
	 * @generated from enum value: PARSER_FORMAT_CSV = 2;
	 */
	CSV = 2,

	/**
	 * @generated from enum value: PARSER_FORMAT_XML = 3;
	 */
	XML = 3,
}

/**
 * @generated from enum workflows.v1.ParserFormat
 */
export type ParserFormatJson = "PARSER_FORMAT_UNSPECIFIED" | "PARSER_FORMAT_JSON" | "PARSER_FORMAT_CSV" | "PARSER_FORMAT_XML";

/**
 * Describes the enum workflows.v1.ParserFormat.
 */
export const ParserFormatSchema: GenEnum<ParserFormat, ParserFormatJson> = /*@__PURE__*/ enumDesc(file_workflows_v1_workflows, 1);

/**
 * @generated from enum workflows.v1.CharacterEncoding
 */
export enum CharacterEncoding {
	/**
	 * @generated from enum value: CHARACTER_ENCODING_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CHARACTER_ENCODING_UTF_16 = 1;
	 */
	UTF_16 = 1,
}

/**
 * @generated from enum workflows.v1.CharacterEncoding
 */
export type CharacterEncodingJson = "CHARACTER_ENCODING_UNSPECIFIED" | "CHARACTER_ENCODING_UTF_16";

/**
 * Describes the enum workflows.v1.CharacterEncoding.
 */
export const CharacterEncodingSchema: GenEnum<CharacterEncoding, CharacterEncodingJson> = /*@__PURE__*/ enumDesc(file_workflows_v1_workflows, 2);
